import { useTranslation } from 'react-i18next';
import { useBuildInfo } from '@/lib/queries';
import { Button } from './ui/button';

export function BuildInfo() {
  const { t } = useTranslation();
  const query = useBuildInfo();
  return (
    <section className="rounded-card border border-line bg-surface px-5 py-4">
      <h2 className="mb-2 font-medium">{t('buildInfo.title')}</h2>
      {query.isError ? (
        <div role="alert">
          <p className="text-sm text-muted">{t('buildInfo.unavailable')}</p>
          <Button onClick={() => void query.refetch()}>{t('common.retry')}</Button>
        </div>
      ) : !query.data ? (
        <p role="status" className="text-sm text-muted">
          {t('common.loading')}
        </p>
      ) : (
        <p className="break-words text-sm text-muted">
          {t('buildInfo.version')}:{' '}
          {query.data.version === 'dev' ? t('buildInfo.development') : query.data.version}
          {query.data.revision !== 'unknown' && (
            <>
              {' '}
              · <span title={query.data.revision}>{query.data.revision.slice(0, 7)}</span>
            </>
          )}
        </p>
      )}
    </section>
  );
}
